module.exports = __webpack_public_path__ + "media/evolve/assets/icons/animated/edit-6a717a71ce2a3c70f842e0cb78978c3d.svg";